// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-pages-Login-___login-module__loginLayout {
  flex: 1;
  overflow-y: auto;
}

.app-pages-Login-___login-module__container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.app-pages-Login-___login-module__form {
  flex: 3;
}

.app-pages-Login-___login-module__project {
  display: flex;
  align-items: center;
  flex: 2;
}

.app-pages-Login-___login-module__nameStart {
  font-family: 'ralewaybold';
}

.app-pages-Login-___login-module__nameEnd {
  margin-top: -2px;
}
`, "",{"version":3,"sources":["webpack://./app/pages/Login/login.module.scss"],"names":[],"mappings":"AAAA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;AACT;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".loginLayout {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n.form {\n  flex: 3;\n}\n\n.project {\n  display: flex;\n  align-items: center;\n  flex: 2;\n}\n\n.nameStart {\n  font-family: 'ralewaybold';\n}\n\n.nameEnd {\n  margin-top: -2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loginLayout": `app-pages-Login-___login-module__loginLayout`,
	"container": `app-pages-Login-___login-module__container`,
	"form": `app-pages-Login-___login-module__form`,
	"project": `app-pages-Login-___login-module__project`,
	"nameStart": `app-pages-Login-___login-module__nameStart`,
	"nameEnd": `app-pages-Login-___login-module__nameEnd`
};
export default ___CSS_LOADER_EXPORT___;
